import templateUrl from './app-nav-header.html';
import findIndex from 'lodash/findIndex';

export const navHeaderComponent = {
	templateUrl,
	// bindings: {
	// 	onLogOut : '&'
	// },
	controller: class HeaderController {
		constructor($state, $transitions, AuthService, DashboardService) {
            'ngInject';

			this.$state = $state;
			this.authService = AuthService;
			this.fetaures = [];
			this.dashboardService = DashboardService;
			this.onStateChangeSuccess.call(this);
            $transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
        }

        onStateChangeSuccess() {
			const state = this.$state.current;
			this.stateName = this.$state.current.name;
			this.featureArray = this.getFeatureArray(state);
			this.featureName = this.featureArray.length > 0 ? this.featureArray[0]: 'dashboard';
			this.fetaures = [];
			this.activeMenuName = this.dashboardService.getActiveMenuName();
			if(!this.activeMenuName) {
				this._redirectToHomeBannerModule();
			}
		}

		getFeatureArray(currentName) {
			let state = this.$state.get(currentName);
			if(state && state.name != 'app.dashboard') {
				this.fetaures.unshift(state.breadcrumbName);
				this.getFeatureArray(state.parentState);
			}
			return this.fetaures;
		}

		$onInit() {
			this.stateName = this.$state.current.name;
			this.user = this.authService.getUser();
			this.accountOptions = [{
				title: 'Change Password',
				value: 'changePassword'
			}, {
				title: 'Logout',
				value: 'logout'
			}];
		}

		onLogOut(){
            this.authService.logout().then((result)=> {
 				this.$state.go('login');
           		this.isLoggedIn = false;
            })
        }

		onOptionsClick(item){
			if(item.value == "logout"){
				this.onLogOut();
			} else if(item.value == "changePassword"){
				this.$state.go('app.dashboard.changePassword');
			}
        }

		//**************************************************** Private Methods **************************************************

		_redirectToHomeBannerModule() {
			this.$state.go('app.dashboard.DynamicMenus',{
				url: 'home-banner'
			});
		}	
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-header.component.js